(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-contact-form"]) return;
  try {
    

  document.getElementById('submitButton').addEventListener('click', function (event) {
    // 检查必填字段
    const requiredFields = ['first-name', 'email', 'city', 'country', 'province', 'subject'];
    for (let field of requiredFields) {
      const input = document.getElementById(field);
      if (!input.value.trim()) {
        // alert(`Please fill out the required field: ${field}`);
        return;
      }
    }
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retailer-form"]) return;
  try {
    
  document.querySelectorAll('.checkbox-group-store input[type="checkbox"]').forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      const selectedValues = Array.from(
        document.querySelectorAll('.checkbox-group-store input[type="checkbox"]:checked')
      ).map((cb) => cb.value);
      document.getElementById('hiddenInput-store').value = selectedValues.join(', ');
    });
  });

  document.querySelectorAll('.radio-group-market input[type="radio"]').forEach((radio) => {
    radio.addEventListener('change', function () {
      const selectedValues = Array.from(
        document.querySelectorAll('.radio-group-market input[type="radio"]:checked')
      ).map((radio) => radio.value);
      document.getElementById('hiddenInput-market').value = selectedValues.join(', ');
    });
  });

  document.querySelectorAll('.checkbox-group-brand input[type="checkbox"]').forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      const selectedValues = Array.from(
        document.querySelectorAll('.checkbox-group-brand input[type="checkbox"]:checked')
      ).map((cb) => cb.value);
      document.getElementById('hiddenInput-brand').value = selectedValues.join(', ');
    });
  });

  document.getElementById('submitButton').addEventListener('click', function (event) {
    // 检查必填字段
    const requiredFields = ['first-name', 'email', 'address', 'city', 'country', 'province', 'zip', 'reason'];
    for (let field of requiredFields) {
      const input = document.getElementById(field);
      if (!input.value.trim()) {
        // alert(`Please fill out the required field: ${field}`);
        return;
      }
    }

    const inputStoreValue = document.getElementById('hiddenInput-store').value;
    const inputMarketValue = document.getElementById('hiddenInput-market').value;
    const inputBrandValue = document.getElementById('hiddenInput-brand').value;
    console.log(inputStoreValue + ' -- ' + inputMarketValue + ' -- ' + inputBrandValue);
    if (inputStoreValue === '') {
      event.preventDefault(); // 防止表单提交
      alert('Please select at least one store type option.');
    } else if (inputMarketValue === '') {
      event.preventDefault(); // 防止表单提交
      alert('Please select one market option.');
    /* } else if (inputBrandValue === '') {
      event.preventDefault(); // 防止表单提交
      alert('Please select at least one brand option.'); */
    } else {
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-rate"] && !window.DesignMode) return;
  try {
    
  const rateSwiper = new Swiper('.rate-swiper-container', {
      slidesPerView: 1,
      direction: 'horizontal',
    loop: false,
    spaceBetween: 10,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-social-media"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Check if we're on mobile
    const isMobile = window.innerWidth < 768;

    // Configure Swiper differently for mobile and desktop
    const swiperSocial = new Swiper('.swiper-social-media', {
      // Optional parameters
      loop: false,
      slidesPerView: 1, // Mobile default
      spaceBetween: 20,

      // Disable swiping on mobile to show static column layout
      allowTouchMove: !isMobile,

      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px (tablets)
        768: {
          slidesPerView: 1.5,
          spaceBetween: 25,
          allowTouchMove: true,
        },
        // when window width is >= 992px (desktops)
        992: {
          slidesPerView: 2.2, // Show 2.2 slides
          spaceBetween: 30,
          allowTouchMove: true,
        },
        // when window width is >= 1200px (large desktops)
        1200: {
          slidesPerView: 2.2, // Show 2.2 slides
          spaceBetween: 30,
          allowTouchMove: true,
        },
      },

      // Navigation arrows - only enable on desktop
      navigation: {
        nextEl: '.swiper-button-next-social',
        prevEl: '.swiper-button-prev-social',
        enabled: !isMobile,
      },

      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous testimonial',
        nextSlideMessage: 'Next testimonial',
      },
    });

    // Handle resize to adjust for orientation changes
    window.addEventListener('resize', function () {
      const isNowMobile = window.innerWidth < 768;
      if (isNowMobile !== isMobile) {
        // Reload the page to reinitialize Swiper with correct settings
        window.location.reload();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-testimonials"] && !window.DesignMode) return;
  try {
    

  const swiper = new Swiper('.swiper', {
    loop:true,
    spaceBetween: 10,
    breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30
    },
    1440: {
      slidesPerView: 3,
      spaceBetween: 40
    }
  },
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section_Image_carousel"] && !window.DesignMode) return;
  try {
    
  const swiper = new Swiper('.swiper-container', {
    slidesPerView: 4,
    loop: true,
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 4000, // 每隔4秒自动切换到下一个幻灯片
      disableOnInteraction: false, // 用户交互后不停止自动播放
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-brisk-it-social-media"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const isMobile = window.innerWidth < 768;
    
    const swiperSocial = new Swiper('.swiper-why-brisk-it-social', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: true,

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next-social',
        prevEl: '.swiper-button-prev-social',
        enabled: !isMobile,
      },

      // Pagination
      pagination: {
        el: '.swiper-pagination-social',
        clickable: true,
        enabled: isMobile,
      },

      breakpoints: {
        992: {
          slidesPerView: 2.2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 2.2,
          spaceBetween: 30,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
